$(function() {
  require('owl.carousel')

  if ($('.-js-articles').length) {
      const jsowl = $('.-js-articles').owlCarousel({
          items: 1,
          nav: false,
          dots: false
      })

      jsowl.on('translated.owl.carousel', function (event) {
          const $isTransitioning = false
          const parent = $(this).parent().parent()
          const year = $(this).find('.active > div > div:first-child span').text()
          $(this).parent().parent().find('.yearbook__controls span').text(year)
          $(this).parent().parent().find('.yearbook__large').text(year)
          parent.find('.yearbook__controls a').removeClass('inactive')
          $('.-js-next-slide').removeClass('slider__controls__arrow--inactive')
          $('.-js-prev-slide').removeClass('slider__controls__arrow--inactive')

          if (event.item.index == 0)
              parent.find('.yearbook__controls a:first-child').addClass('inactive')

          if (event.item.index == event.item.count - 1)
              parent.find('.yearbook__controls a:last-child').addClass('inactive')


      })

      $('.yearbook__controls ').on('click', 'a:last-child', function (e) {
          e.preventDefault()

          const owl = $(this).parent().parent().find('.-js-articles')
          owl.trigger('next.owl.carousel')
          const date = $(this).parent()
      })
      $('.yearbook__controls ').on('click', 'a:first-child', function (e) {
          e.preventDefault()

          const owl = $(this).parent().parent().find('.-js-articles')
          owl.trigger('prev.owl.carousel')
          const date = $(this).parent()
      })
  }

  new WOW().init()
})
